export interface SkeletonProps {
  className?: string;
  /**
   * `shimmer` draws the prototype's `.sk` (Story #26134): the --sk block with its --sk-hi shimmer and 8px corners, the
   * shimmer stopping under reduced motion. The default `pulse` keeps the look every existing screen was built with.
   */
  look?: 'pulse' | 'shimmer';
}

/**
 * Animated skeleton placeholder. Matches the shape of the content it replaces.
 * Uses animate-pulse per frontend-ui-system.md, or the prototype's shimmer (`look="shimmer"`).
 */
export function Skeleton({ className = 'h-4 w-full', look = 'pulse' }: SkeletonProps) {
  const base = look === 'shimmer' ? 'ui-sk' : 'animate-pulse rounded bg-[var(--surface2)]';
  return (
    <div
      className={`${base} ${className}`}
      aria-hidden="true"
    />
  );
}
